import { CookieType } from "@/enum/CookieType";
import Cookies from "js-cookie";

/**
 * 프론트(`www.dev.codepresso.kr`)와 IdP/API 가 사용하는 형제 도메인(`api-dev.codepresso.kr`)에
 * AccessToken 쿠키가 모두 전송되도록 부모 도메인을 `.codepresso.kr` 로 부여한다.
 * dev/prod 모두 같은 정책. localhost/IP 등은 host-only.
 *
 * NOTE: 같은 `.codepresso.kr` 아래 dev/prod 가 공존하지만 JWT 시크릿이 환경별로 달라
 *       dev 쿠키는 prod backend 에서 검증 실패 → 보안적으로 OK.
 */
const getCookieDomain = (): string | undefined => {
  const host = window.location.hostname;
  if (host === "codepresso.kr" || host.endsWith(".codepresso.kr")) {
    return ".codepresso.kr";
  }
  return undefined;
};

const buildOptions = (
  extra: Cookies.CookieAttributes = {}
): Cookies.CookieAttributes => {
  const options: Cookies.CookieAttributes = { path: "/", ...extra };
  const domain = getCookieDomain();
  if (domain) options.domain = domain;
  return options;
};

const setCookie = (
  cookieType: CookieType,
  value: string | object,
  expires = 0
): void => {
  const v = value as string;
  if (expires !== 0) {
    Cookies.set(cookieType, v, buildOptions({ expires }));
  } else {
    Cookies.set(cookieType, v, buildOptions());
  }
};

const getCookie = (cookieType: CookieType): string | undefined => {
  return Cookies.get(cookieType);
};

const removeCookie = (cookieType: CookieType): void => {
  Cookies.remove(cookieType, buildOptions());
};

export { setCookie, getCookie, removeCookie };
